import { LimitedStringSet } from './limited-string-set.esm.js';

var MAX_SET_SIZE = 100;
/**
 * ImageQueue Notes:
 * - Does not handle duplicate entries any differently. (LOC to ROI is very poor)
 */
var ImageQueue = /** @class */ (function () {
    function ImageQueue(_a) {
        var _b = _a === void 0 ? { maxConnections: 3 } : _a, maxConnections = _b.maxConnections;
        this.reset();
        this.maxConnections = maxConnections;
    }
    ImageQueue.prototype.reset = function () {
        this.queue = [];
        this.runners = [];
        this.completedUrls = new LimitedStringSet(MAX_SET_SIZE);
    };
    /*
      Source = string identifier, eg: 'hsr'
      imageUrl (required) = image to download
      imgRef = ref to an existing Image to load image to
      callback = (error) => {}
     */
    ImageQueue.prototype.enqueue = function (_a) {
        var source = _a.source, imageUrl = _a.imageUrl, imgRef = _a.imgRef, callback = _a.callback;
        this.queue.push({ source: source, imageUrl: imageUrl, imgRef: imgRef, callback: callback });
        if (this.runners.length < this.maxConnections) {
            this._loadImages();
        }
    };
    ImageQueue.prototype.dequeue = function (imageUrl, source) {
        this.queue = this.queue.filter(function (item) { return !(item.imageUrl === imageUrl && (!source || item.source === source)); } // Easier to reason about !(dequeueMatch) for filtering
        );
    };
    ImageQueue.prototype.dequeueAll = function (source) {
        this.queue = this.queue.filter(function (item) { return item.source !== source; });
    };
    ImageQueue.prototype._loadImages = function () {
        var _this = this;
        this.queue.splice(0, this.maxConnections - this.runners.length).forEach(function (task) {
            _this._downloadImage(task);
        });
    };
    ImageQueue.prototype._downloadImage = function (task) {
        var _this = this;
        var image = task.imgRef || new Image();
        var handler = function (error) { return function () {
            var index = _this.runners.findIndex(function (item) { return item.imageUrl === task.imageUrl && (!task.source || item.source === task.source); });
            if (index >= 0) {
                _this.runners.splice(index, 1);
            }
            Promise.resolve().then(function () { return _this._loadImages(); });
            _this.completedUrls.add(task.imageUrl);
            if (task.callback) {
                // Call the callback immediately to prevent image-change jitter.
                task.callback(error);
            }
        }; };
        if (this.completedUrls.has(task.imageUrl)) {
            handler()();
            return;
        }
        image.onerror = handler(new Error("Error loading image URL: ".concat(task.imageUrl)));
        image.onload = handler();
        image.src = task.imageUrl;
        // eslint-disable-next-line no-param-reassign
        task.imgRef = image;
        this.runners.push(task);
    };
    return ImageQueue;
}());
var queue = new ImageQueue({ maxConnections: 4 });

export { ImageQueue, queue };
